import axios from 'axios';

export class RestrictionsService {

    getRestrictionsPosture(folio) {
        return axios.get('/appapv/getRestrictionsPosture.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                folioPrestamo: folio,
            }
        }).then(res => res.data.payload);
    }

    getRestrictions() {
        return axios.get('/appapv/getRestrictions.action', {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => res.data);
    }

    getRestrictionsLoan(folio) {
        return axios.get('/appapv/getRestrictionsLoan.action', {
            params: {
                folio: folio,
            }
        }).then(res => res.data.payload);
    }
}